import { render, staticRenderFns } from "./promote-controls.vue?vue&type=template&id=77edd9d2"
import script from "./promote-controls.vue?vue&type=script&lang=ts"
export * from "./promote-controls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports